import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgFacebookOfficial = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<clipPath id="a"><path d="M0 0h32v32H0z" /></clipPath><g clipPath="url(#a)"><path fill="currentColor" d="M1.778 0h28.444c1 0 1.778.778 1.778 1.778v28.444c0 1-.778 1.778-1.778 1.778h-8.148V19.593h4.148l.63-4.815h-4.778v-3.074c0-1.408.37-2.334 2.407-2.334l2.556-.037V5.037c-.444-.074-1.963-.222-3.74-.222-3.667 0-6.223 2.26-6.223 6.407v3.556h-4.148v4.815h4.148V32H1.778C.778 32 0 31.222 0 30.222V1.778C0 .778.778 0 1.778 0z" /></g></svg>;
export default SvgFacebookOfficial;